// @flow

import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { localize } from "redux-i18n";

import actionCreators from "@modules/service/actionCreator";
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from "@components";
import type { EmailNotification } from "@modules/service/reducer/email-notifications/types";

type OwnProps = $Exact<{
  clientId: ?number,
  data: ?EmailNotification,
}>;

type PropsFromDispatch = $Exact<{
  setShowModal: typeof actionCreators.SetShowDeleteEmailNotificationModal,
  delete: typeof actionCreators.DeleteEmailNotification,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
  ...PropsFromDispatch,
}>;

export class EmailNotificationDeleteModal extends React.Component<Props> {
  handleCancel = () => {
    this.props.setShowModal(false);
  };

  handleSubmit = () => {
    this.props.delete({ clientId: this.props.clientId, ruleId: (this.props.data || {}).id });
  };

  render() {
    return (
      <Modal className="modal-small">
        <ModalHeader className="d-flex justify-content-between" toggle={this.handleCancel}>
          {this.props.t("EMAIL_NOTIFICATION_DELETE_TITLE")}
        </ModalHeader>
        <ModalBody className="d-flex flex-column justify-content-start align-content-center">
          <p className="text-greyish-brown">
            {this.props.t("EMAIL_NOTIFICATION_DELETE_QUESTION", {
              id: (this.props.data || {}).id,
            })}
          </p>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.handleCancel}>
            {this.props.t("CANCEL")}
          </Button>
          <Button onClick={this.handleSubmit} materialIcon="delete_forever">
            {this.props.t("EMAIL_NOTIFICATION_DELETE_SUBMIT_TEXT")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapDispatchToProps: PropsFromDispatch = {
  setShowModal: actionCreators.SetShowDeleteEmailNotificationModal,
  delete: actionCreators.DeleteEmailNotification,
};

export default compose(localize(), connect(null, mapDispatchToProps))(EmailNotificationDeleteModal);
